export default __webpack_public_path__ + "static/media/mentor_mock_3.8ee28671.png";